import { createApp, h }     from 'vue'
import { createInertiaApp } from '@inertiajs/vue3'
import { ZiggyVue }         from "ziggy-js";
import translate            from "@Plugins/translate";
import asset                from "@Plugins/asset";
import localeRoute          from "@Plugins/localeRoute";
import { createPinia }      from "pinia";

createInertiaApp({
    resolve: name => {
        // @ts-ignore
        const pages = import.meta.glob('./View/Pages/**/*.vue', {eager: true});

        return pages[`./View/Pages/${name}.vue`];
    },
    setup({el, App, props, plugin}) {
        createApp({render: () => h(App, props)})
            .use(plugin)
            .use(ZiggyVue)
            .use(translate)
            .use(asset)
            .use(localeRoute)
            .use(createPinia())
            .mount(el);
    },
});
